<template>
  <div class="card-form">
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          NO：{{ flipOrderForm.amzFlipOrderNo }}
        </span>
        <el-divider direction="vertical"> </el-divider>
        <b-badge class="mr-2" style="font-size: 12px" variant="info">
          {{ flipOrderForm.v_skuSalesChannel }}
        </b-badge>
        <el-divider direction="vertical"> </el-divider>
        <b-badge
          class="mr-2"
          style="font-size: 12px"
          :variant="
            flipOrderForm.amzFlipOrderStatus == 'N'
              ? 'info'
              : flipOrderForm.amzFlipOrderStatus == 'S'
              ? 'primary'
              : flipOrderForm.amzFlipOrderStatus == 'P'
              ? 'success'
              : flipOrderForm.amzFlipOrderStatus == 'R'
              ? 'danger'
              : flipOrderForm.amzFlipOrderStatus == 'D'
              ? 'danger'
              : flipOrderForm.amzFlipOrderStatus == 'T'
              ? 'primary'
              : flipOrderForm.amzFlipOrderStatus == 'A'
              ? 'success'
              : flipOrderForm.amzFlipOrderStatus == 'B'
              ? 'danger'
              : 'primary'
          "
        >
          {{ flipOrderForm.v_amzFlipOrderStatus || '草稿' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{
            flipOrderForm.modifyByName ? flipOrderForm.modifyByName : '--'
          }}
          at
          {{ flipOrderForm.modifyTime ? flipOrderForm.modifyTime : '--' }}
        </span>
      </div>
    </div>
        <div
      style="    font-size: 15px;
    color: rgb(96, 98, 102);
    font-weight: 600;"
      class="mt-2 mb-2"
    >
      {{ flipOrderForm.title }}
    </div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      :tablePage="page"
      @reload="reload"
      @choose-change="(e) => (checkedRows = e)"
    >
      <template slot="header">
        <div class="table_toolbar">
          <page-header ref="header" @query="getData" @reset="resetPage">
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="reviewVisible = true"
              v-if="allow('C')"
            >
              {{ $l('btn_moq_confirm') || 'MOQ确认' }}
            </b-button>
          </page-header>
        </div>
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <Review
      v-if="reviewVisible"
      :visible.sync="reviewVisible"
      :amzFlipOrderCode="amzFlipOrderCode"
      @close="reviewVisible = false"
    ></Review>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import Review from '../review'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, Review },
  props: {
    amzFlipOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
      reviewVisible: false,
      table: [],
      checkedRows: [],
      flipOrderForm: {},
      orderSkuStatus: 'S',
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.amzFlipOrderCode) {
        this.$api
          .ecomAmzFlipOrderDetailApi({
            amzFlipOrderCode: this.amzFlipOrderCode,
          })
          .then((res) => {
            this.flipOrderForm = { ...res.body }
            this.spuNoListBak = Object.assign(
              [],
              this.flipOrderForm.spuNoList || []
            )
          })
      }
    },
    getData(form) {
      this.loading = true
      this.checkedRows = []
      let params = {}
      if (this.orderSkuStatus) {
        params['amzFlipOrderSkuStatusList'] = [this.orderSkuStatus]
      }
      this.$api
        .ecomAmzFlipOrderSkuListApi({
          ...form,
          ...this.page,
          ...params,
          amzFlipOrderCode: this.amzFlipOrderCode,
        })
        .then((res) => {
          this.loading = false
          const tmpData = res.body.data || []
          const pageSize = res.body.pageSize
          const curPage = res.body.curPage
          let start = (curPage - 1) * pageSize
          const tableData = []
          let amzFlipOrderSkuCode = ''
          for (let i = 0; i < tmpData.length; i++) {
            const orderInfo = tmpData[i]
            orderInfo.seq = start + i + 1
            const orderMarketInfo = orderInfo.marketInfos || [{ ...orderInfo }]
            orderMarketInfo.map((e) => {
              if (amzFlipOrderSkuCode != orderInfo.amzFlipOrderSkuCode) {
                amzFlipOrderSkuCode = orderInfo.amzFlipOrderSkuCode
                orderInfo['rowspan'] = orderMarketInfo.length
              } else {
                orderInfo['rowspan'] = 0
              }
              tableData.push({ ...e, ...orderInfo })
            })
          }
          res.body.data = tableData
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.table_toolbar {
  display: flex;
  justify-content: space-between;
  .search-form {
    width: 100%;
  }
  .search-container {
    margin-right: 10px;
  }
  .toolbar_tools {
    display: flex;
    align-items: center;
    margin-right: 12px;
    .vxe-button--content {
      i {
        font-size: 13px;
      }
    }
  }
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
